import { Link } from "react-router-dom";
import { BookOpen, Heart } from "lucide-react";

export const Footer = () => (
  <footer className="bg-nordic-muted border-t border-nordic-wood/20 py-16" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <BookOpen className="w-5 h-5 text-nordic-blue" />
            <span className="font-heading text-lg font-semibold text-nordic-text">Bildkort</span>
          </Link>
          <p className="text-sm text-nordic-text-secondary leading-relaxed max-w-xs">
            Learn Swedish the natural way — through beauty, simplicity, and connection.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-nordic-text mb-4 uppercase tracking-wider">Learn</h4>
          <div className="flex flex-col gap-2">
            <Link to="/gallery" className="text-sm text-nordic-text-secondary hover:text-nordic-blue" style={{ transition: "color 0.2s" }} data-testid="footer-explore">Explore Words</Link>
            <Link to="/flashcards" className="text-sm text-nordic-text-secondary hover:text-nordic-blue" style={{ transition: "color 0.2s" }} data-testid="footer-flashcards">Flashcards</Link>
            <Link to="/quiz" className="text-sm text-nordic-text-secondary hover:text-nordic-blue" style={{ transition: "color 0.2s" }} data-testid="footer-quiz">Quiz</Link>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-nordic-text mb-4 uppercase tracking-wider">Categories</h4>
          <div className="flex flex-col gap-2">
            {["nature", "feelings", "food", "daily_life", "colors"].map((cat) => (
              <Link key={cat} to={`/gallery/${cat}`} className="text-sm text-nordic-text-secondary hover:text-nordic-blue capitalize" style={{ transition: "color 0.2s" }}>
                {cat.replace("_", " ")}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-nordic-wood/20 flex items-center justify-center gap-1 text-sm text-nordic-text-muted">
        Made with <Heart className="w-3.5 h-3.5 text-nordic-error fill-nordic-error" /> for Swedish learners everywhere
      </div>
    </div>
  </footer>
);
